import { render } from "./RouletteBets.vue?vue&type=template&id=6dcb4b18&scoped=true"
import script from "./RouletteBets.vue?vue&type=script&lang=js"
export * from "./RouletteBets.vue?vue&type=script&lang=js"

import "./RouletteBets.vue?vue&type=style&index=0&id=6dcb4b18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcb4b18"]])

export default __exports__